<form class="form-horizontal" [formGroup]="remittanceForm">
    <accordion-group [isOpen]="true" *ngIf="!isShortFormActiveForPlan">
        <span accordion-heading>
            <i class='fa fa-user'></i> Datos Generales
          </span>
        <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Ingreso</b>
              <span appRequiredAsterisk [formGroup]="remittanceForm" controlName="incomeAmount"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
                <input type="number" class="form-control" formControlName="incomeAmount" [ngClass]="remittanceForm.controls.incomeAmount.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
            </div>
          </div>
    </accordion-group>
    <accordion-group [isOpen]="true">
        <span accordion-heading>
            <i class='fa fa-list'></i> Datos de Remesa
          </span>
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Nombre del Remitente</b>
              <span appRequiredAsterisk [formGroup]="remittanceForm" controlName="remittanceName"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input type="text" class="form-control" formControlName="remittanceName" [ngClass]="remittanceForm.controls.remittanceName.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
              <!--  -->
            </div>
          </div> 
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Parentesco</b>
              <span appRequiredAsterisk [formGroup]="remittanceForm" controlName="familyRelationship"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
                <ng-select formControlName="familyRelationship" [items]="familyRelationships" bindLabel="value" bindValue="key" [readonly]="readonly"></ng-select>
              <!--  -->
            </div>
          </div> 
          <div class="form-group row">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Procedencia</b>
              <span appRequiredAsterisk [formGroup]="remittanceForm" controlName="incomeOrigin"></span>
            </label>
            <div class="col-10 col-md-10 col-sm-8 ">
                <ng-select formControlName="incomeOrigin" [items]="incomeOrigins" bindLabel="value" bindValue="key" [readonly]="readonly"></ng-select>
              <!--  -->
            </div>
          </div> 
          <div class="form-group row" *ngIf="!isShortFormActiveForPlan">
            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Desde cuando las recibe</b>
              <span appRequiredAsterisk [formGroup]="remittanceForm" controlName="receivingDate"></span>
          </label>
            <div class="col-10 col-md-10 col-sm-8 ">
              <input bsDatepicker class="form-control" formControlName="receivingDate" [bsConfig]="{ isAnimated: true, containerClass:'theme-blue', displayOneMonthRange: true, selectFromOtherMonth:true }" [ngClass]="remittanceForm.controls.receivingDate.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
              <!--  -->
            </div>
          </div>
    </accordion-group>
</form>